function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import classNames from 'classnames';
const InputCore = /*#__PURE__*/forwardRef(({
  as: Component = Form.Control,
  label,
  labelAppend,
  labelPrepend,
  displayLabel = true,
  value,
  rules,
  name,
  id,
  onChange,
  state,
  required,
  validable,
  formGroupClassName,
  description,
  helpText,
  length,
  iconAppend,
  iconPrepend,
  prepend,
  append,
  barelyAppend,
  barelyPrepend,
  formGroupAppend,
  stripped,
  ...props
}, ref) => {
  const isTextarea = props.type === 'textarea';
  return stripped ? /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref
  }, props, {
    as: isTextarea ? 'textarea' : undefined,
    name: name,
    id: id || name,
    value: props.type !== 'file' ? state.value : undefined,
    isInvalid: state.isInvalid,
    isValid: validable ? state.isValidated && !state.isInvalid : undefined,
    onChange: onChange,
    maxLength: length
  })) : /*#__PURE__*/React.createElement(Form.Group, {
    className: formGroupClassName
  }, displayLabel && label && /*#__PURE__*/React.createElement(Form.Label, {
    htmlFor: id || name,
    className: !!helpText ? 'mb-0' : undefined
  }, labelPrepend, label, required && /*#__PURE__*/React.createElement("span", {
    className: "text-danger"
  }, " *"), labelAppend), helpText && /*#__PURE__*/React.createElement(Form.Text, {
    className: "form-help-text text-muted mt-0 mb-1"
  }, helpText), iconAppend || iconPrepend || prepend || append || barelyAppend || barelyPrepend ? /*#__PURE__*/React.createElement(InputGroup, {
    className: classNames('', {
      'is-invalid': state.isInvalid,
      'is-valid': validable ? state.isValidated && !state.isInvalid : undefined
    })
  }, iconPrepend && /*#__PURE__*/React.createElement(InputGroup.Prepend, null, /*#__PURE__*/React.createElement(InputGroup.Text, null, iconPrepend)), prepend && /*#__PURE__*/React.createElement(InputGroup.Prepend, null, prepend), barelyPrepend, /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref
  }, props, {
    as: isTextarea ? 'textarea' : undefined,
    name: name,
    id: id || name,
    value: props.type !== 'file' ? state.value : undefined,
    isInvalid: state.isInvalid,
    isValid: validable ? state.isValidated && !state.isInvalid : undefined,
    onChange: onChange,
    maxLength: length
  })), barelyAppend, append && /*#__PURE__*/React.createElement(InputGroup.Append, null, append), iconAppend && /*#__PURE__*/React.createElement(InputGroup.Append, null, /*#__PURE__*/React.createElement(InputGroup.Text, null, iconAppend))) : /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref
  }, props, {
    as: isTextarea ? 'textarea' : undefined,
    name: name,
    id: id || name,
    value: props.type !== 'file' ? state.value : undefined,
    isInvalid: state.isInvalid,
    isValid: validable ? state.isValidated && !state.isInvalid : undefined,
    onChange: onChange,
    maxLength: length
  })), /*#__PURE__*/React.createElement(Form.Control.Feedback, {
    type: "invalid"
  }, state.message), !state.isInvalid && description && /*#__PURE__*/React.createElement(Form.Text, {
    className: "form-description text-muted d-flex"
  }, description, " ", length && typeof state.value === 'string' && /*#__PURE__*/React.createElement("span", {
    className: "ml-auto"
  }, "(", state.value.replace(/\<.+?\>/g, "")?.length, "/", length, ")")), formGroupAppend);
});
export default InputCore;